module.exports = __webpack_public_path__ + "static/bulb-d9841b4e2a635ef1c6cd04cbb26e1e87.png";